import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarRegla = async (regla) => {
    const configs = { headers: getHeaders() };

    try {
        if (regla.id !== "") {
            const resp = await axios.put(
                `${API_URL}/reglas/${regla.id}`,
                regla,
                configs
            );
            return resp.data;
        }

        const resp = await axios.post(`${API_URL}/reglas`, regla, configs);
        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarRegla = async (id_regla) => {
    try {
        const resp = await axios.delete(`${API_URL}/reglas/${id_regla}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarRegla = async (id_regla) => {
    try {
        const resp = await axios.get(`${API_URL}/reglas/activar/${id_regla}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarRegla = async (id_regla, empleados) => {
    try {
        const resp = await axios.post(
            `${API_URL}/reglas/${id_regla}/asignar`,
            { empleados },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerReglaPorId = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/reglas/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
